import { scenarioSchema } from '@orgsim/shared';
import demo from '@orgsim/shared/examples/demo.json';

// The bundled example scenario, parsed once so a broken example fails loudly at startup.
export const DEMO_SCENARIO = scenarioSchema.parse(demo);
